export enum ReferenceType {
    Unknown = 0,
    Character = 1,
    Educare = 2,
    Childcare = 3,
    PreviousHostFamily = 4,
    FamilyMember = 5
}